<div class="container-fluid d-flex p-0">
  <app-side-bar></app-side-bar>

  <div class="container-fluid p-0" style="background: #fff; min-height: 100vh;">
    <!-- HEADER BLOCK -->
    <div class="container-fluid my-3">
      <div class="top-card">
        <div class="header-content">
          <span>Shortage Panel</span>
        </div>
        <div class="header-right">
          Total Count: {{totalCount | number}} &middot; Last updated: {{lastUpdated | date:'MMM dd, yyyy'}}
        </div>
      </div>
    </div>

    <!-- SPACING AND CONTENT -->
    <div class="container-fluid">
      <!-- HORIZONTAL NAVIGATION -->
      <div class="nav-bar">
        <div class="nav-tab" [class.active]="currentView === 'overview'" (click)="switchView('overview')">
          <span>📊</span> Overview
        </div>
        <div class="nav-tab" [class.active]="currentView === 'changelog'" (click)="switchView('changelog')">
          <span>📋</span> Change Logs
        </div>
        <div class="nav-tab" [class.active]="currentView === 'timeline'" (click)="switchView('timeline')">
          <span>⏳</span> Recovery Panel
        </div>
        <!-- <div class="nav-tab" [class.active]="currentView === 'comments'" (click)="switchView('comments')">
          <span>💬</span> Comments Group
        </div> -->
        <div class="nav-tab" [class.active]="currentView === 'explorer'" (click)="switchView('explorer')">
          <span>📂</span> Data Explorer
        </div>
      </div>

      <!-- TOGGLE BAR -->
      <div class="toggle-section" *ngIf="currentView === 'overview'">
        <div class="toggle-group">
          <span style="font-size:12px; font-weight:700">PRODUCTS </span>
          <label class="switch">
            <input type="checkbox" [checked]="currentMode === 'NDC'" (change)="handleModeToggle($event)">
            <span class="slider"></span>
          </label>
          <span style="font-size:12px; font-weight:700"> NDC</span>
          <span class="badge" [ngClass]="currentMode === 'Products' ? 'badge-plum' : 'badge-blue'"
            style="margin-left:12px">
            {{currentMode === 'Products' ? 'Viewing: Mapped Products' : 'Viewing: All NDC Records'}}
          </span>
        </div>
      </div>

      <!-- OVERVIEW VIEW -->
      <app-shortage-overview *ngIf="currentView === 'overview'" [allData]="allData" [currentMode]="currentMode"
        (filterRedirect)="filterAndRedirect($event)">
      </app-shortage-overview>

      <!-- CHANGE LOG VIEW -->
      <app-shortage-changelog *ngIf="currentView === 'changelog'">
      </app-shortage-changelog>

      <!-- RECOVERY PANEL VIEW -->
      <app-shortage-recovery-panel *ngIf="currentView === 'timeline'">
      </app-shortage-recovery-panel>

      <!-- COMMENTS GROUP VIEW -->
      <app-shortage-comments *ngIf="currentView === 'comments'" [allData]="allData">
      </app-shortage-comments>

      <app-shortage-explorer *ngIf="currentView === 'explorer'" [initialFilters]="explorerInitialFilters">
      </app-shortage-explorer>
    </div>
  </div>
</div>